export default "__VITE_ASSET__04941869__"